// extracted by mini-css-extract-plugin
module.exports = {"option":"menuForPromotions_option__1PbhD","noneHover":"menuForPromotions_noneHover__HZqtR"};